import React, { useContext, useState } from 'react';
import { useStyletron } from 'baseui';
import { Checkbox, STYLE_TYPE } from 'baseui/checkbox';
import { FormControl } from 'baseui/form-control';
import { Input } from 'baseui/input';
import { Segment, SegmentedControl } from 'baseui/segmented-control';
import { Button } from '@gtintel/platform-atoms';
import { AdjustmentType } from '@gtintel/platform-types';
import { ProjectContext } from '../../ProjectApp/context';
import { useAdjustments } from './AdjustmentContext';
const AdjustmentForm = ({
  hideModal
}) => {
  const [css] = useStyletron();
  const {
    currency
  } = useContext(ProjectContext);
  const {
    proposeAdjustment,
    newAdjustment,
    setPriceType,
    submitAdjustment
  } = useAdjustments();
  const [shouldConfirm, setShouldConfirm] = useState(false);
  const [formValidation, setFormValidation] = useState({
    amount: true,
    reasonMin: true,
    reasonMax: true
  });
  const [formErrors, setFormErrors] = useState({
    amount: undefined,
    reason: undefined
  });
  const [isDiscount, setIsDiscount] = useState(false);
  const validateForm = () => {
    const formValidation = {
      amount: newAdjustment.amount !== 0,
      reasonMin: newAdjustment.reason.length > 10,
      reasonMax: newAdjustment.reason.length < 255
    };
    if (formValidation.amount && formValidation.reasonMin && formValidation.reasonMax) {
      setShouldConfirm(true);
      setFormErrors({
        amount: undefined,
        reason: undefined
      });
    } else {
      setFormErrors({
        amount: !formValidation.amount ? 'Please enter an amount.' : undefined,
        reason: !formValidation.reasonMax ? 'Please keep the reason under 255 characters.' : 'Please explain why the price is being adjusted.'
      });
    }
    setFormValidation(formValidation);
  };
  return <div className={css({
    display: 'grid',
    gridTemplateColumns: '1fr  1.5fr 1.5fr .5fr',
    gap: '8px'
  })}>
      <div>
        <FormControl label="Type">
          <SegmentedControl activeKey={newAdjustment.adjustment_type} onChange={({
          activeKey
        }) => {
          proposeAdjustment({
            ...newAdjustment,
            adjustment_type: activeKey
          }, isDiscount);
          setPriceType(activeKey);
        }} overrides={{
          Root: {
            style: {
              fontSize: '10px'
            }
          }
        }}>
            <Segment label="Client" key={AdjustmentType.client_price} />
            <Segment label="Partner" key={AdjustmentType.partner_price} />
          </SegmentedControl>
        </FormControl>
      </div>

      <div>
        <FormControl label="Amount" error={formErrors.amount}>
          <Input onChange={e => {
          proposeAdjustment({
            ...newAdjustment,
            amount: +e.target.value
          }, isDiscount);
        }} value={newAdjustment.amount} startEnhancer={() => currency} endEnhancer={<Checkbox checked={isDiscount} checkmarkType={STYLE_TYPE.toggle} onChange={() => {
          proposeAdjustment(newAdjustment, !isDiscount);
          setIsDiscount(!isDiscount);
        }}>
                Discount
              </Checkbox>} required inputMode="numeric" pattern="-?[0-9]*" error={!formValidation.amount} />
        </FormControl>
      </div>

      <div>
        <FormControl label="Reason" error={formErrors.reason}>
          <Input onChange={e => proposeAdjustment({
          ...newAdjustment,
          reason: e.target.value
        }, isDiscount)} value={newAdjustment.reason} type="text" required inputMode="text" pattern="[A-Za-z0-9]{10,255}" error={!formValidation.reasonMax || !formValidation.reasonMin} />
        </FormControl>
      </div>

      <div className={css({
      paddingTop: '30px'
    })}>
        {shouldConfirm ? <Button kind="success" onClick={() => {
        submitAdjustment();
        setShouldConfirm(false);
        hideModal();
      }}>
            Confirm
          </Button> : <Button kind="primary" onClick={() => {
        validateForm();
      }}>
            Add
          </Button>}
      </div>
    </div>;
};
export default AdjustmentForm;